export default __webpack_public_path__ + "static/media/blueThreeDots.b19ff714.svg";